import * as React from 'react';
import NavBar from "../components/NavBar";
import {Dialpad, Fingerprint, Https, SaveOutlined, VerifiedUser, Visibility, VisibilityOff} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {Box, CircularProgress} from "@mui/material";
import {PatternFormat} from 'react-number-format';
import {handleBorderColor, HandleValidationMethod, removeNonNumeric, useShowMessageComponent} from "../assets/js/main";
import {useLocation, useNavigate} from "react-router-dom";
import HandleFetchData from "../plugin/HandleFetchData";
import {useDispatch, useSelector} from "react-redux";
import {setValidations} from "../redux/public/actions";


export default function SettingAccount() {
  const {t} = useTranslation()
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const {fetchData} = HandleFetchData()
  const {validationMethod} = HandleValidationMethod()
  const {showMessageComponent} = useShowMessageComponent()

  const firstNameRef = React.useRef()
  const lastNameRef = React.useRef()
  const nationalCodeRef = React.useRef()

  const passwordRef = React.useRef()
  const confirmPasswordRef = React.useRef()
  const codeRef = React.useRef()

  const [isLoadingInfo, setLoadingInfo] = React.useState(false)
  const [isLoadingPass, setLoadingPass] = React.useState(false)
  const [firstName, setFirstName] = React.useState('')
  const [lastName, setLastName] = React.useState('')
  const [affiliate, setAffiliate] = React.useState('')
  const [phoneNumber, setPhoneNumber] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [confirmPassword, setConfirmPassword] = React.useState('')
  const [verifyCode, setVerifyCode] = React.useState('')
  const [changePass, setChangePass] = React.useState(false)
  const [nationalCode, setNationalCode] = React.useState('');
  const [cartNumber, setCartNumber] = React.useState('');
  const [ibanNumber, setIbanNumber] = React.useState('');
  const [errOnlyEnglish, setErrOnlyEnglish] = React.useState('')
  const [showPassword, setShowPassword] = React.useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false)

  React.useEffect(() => {
    const info = JSON.parse(localStorage.getItem('info-user'))
    setFirstName(info?.FullName?.split(' ')[0])
    setLastName(info?.FullName?.split(' ')[1])
    setPhoneNumber(info?.Mobile)
  }, [])

  const onlyEnglish = (e) => {
    var re = new RegExp(/[^A-Za-z0-9!@#\$%\^\&*]/g);
    if (re.test(e.toString())) {
      setErrOnlyEnglish('کیبورد خود را به انگلیسی تغییر دهید')
      return e.toString().replace(re, "")
    } else {
      setErrOnlyEnglish('')
      return e.toString()
    }
  };

  const validationInfo = () => {
    if (!firstName) {
      validationMethod(firstNameRef, 'firstName', t("error.t4"))
    } else if (!lastName) {
      validationMethod(lastNameRef, 'lastName', t("error.t5"))
    } else if (!nationalCode) {
      validationMethod(nationalCodeRef, 'nationalCode', t("error.t31"))
    } else {
      changeInfoUser()
    }
  }

  const validationPasswords = () => {
    if (!password) {
      validationMethod(passwordRef, 'password', t("error.t32"))
    } else if (!confirmPassword) {
      validationMethod(confirmPasswordRef, 'confirmPassword', t("error.t33"))
    } else if (password !== confirmPassword) {
      showMessageComponent(t("error.t34"), 'error')
    } else {
      sentUsername()
    }
  }

  const validationCode = () => {
    if(!verifyCode){
      validationMethod(codeRef, 'verifyCode', t("error.t35"))
    }else{
      handleNewPassword()
    }
  }

  const changeInfoUser = async () => {
    setLoadingInfo(true)
    dispatch(setValidations(null))
    let fetch = await fetchData('', 'POST', '/updateCustomerInfo', {
         "firstName": firstName,
         "lastName": lastName,
         "nationalCode": nationalCode,
         "ibanNumber": ibanNumber,
         "bankCardNo": cartNumber
       },
       "application/json", '', '', ''
    )

    if (fetch?.IsSuccess) {
      await getUserInfo()
      await showMessageComponent(fetch?.Message, 'success')
    } else {
      await showMessageComponent(fetch?.Message, 'error')
    }

    setLoadingInfo(fetch.isLoading)
  }


  const getUserInfo = async () => {
    setLoadingInfo(true)
    let fetch = await fetchData('', 'GET', `/getCustomerInfo`, '', 'application/json', '', '', '')
    setLoadingInfo(false)
    localStorage.setItem('info-user', JSON.stringify(fetch?.Data))
    setFirstName(fetch?.Data?.FullName?.split(' ')[0])
    setLastName(fetch?.Data?.FullName?.split(' ')[1])
    setPhoneNumber(fetch?.Data?.Mobile)
    setNationalCode(fetch?.Data?.nationalCode)
    setIbanNumber(fetch?.Data?.ibanNumber)
    setCartNumber(fetch?.Data?.bankCardNo)
    window.location.reload();
  }

  // متد ارسال کد یکبالرمصرف
  const sentUsername = async () => {
    setLoadingPass(true)
    let fetch = await fetchData('', 'GET', `/RequestForgetPassword`, '',
       "application/x-www-form-urlencoded", {
         userName: phoneNumber,
       }, '', ''
    )
    if (fetch?.success) {
      setChangePass(true)
      showMessageComponent(fetch?.message, 'success')
    } else {
      showMessageComponent(fetch?.message, 'error')
    }

    setLoadingPass(false)
  }
  // متد ارسال کد یکبالرمصرف

  const handleNewPassword = async () => {
    setLoadingPass(true)
    dispatch(setValidations(null))
    let fetch = await fetchData('', 'POST', `/verifyForgetPassword`, '',
       "application/x-www-form-urlencoded", {
         userName: phoneNumber,
         Code: verifyCode,
         Password: password,
         NewPawssord: confirmPassword
       }, '', ''
    )

    if (fetch?.success) {
      setChangePass(false)
      showMessageComponent(fetch?.message, 'success')
    }if (!fetch?.success) {
      showMessageComponent(fetch?.message, 'error')
    } else if (fetch && fetch?.status == 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    } else {
      showMessageComponent(fetch?.response?.data?.message, 'error')
    }

    setLoadingPass(false)
  }


  return (
     <>
       <NavBar blue back/>
       <div className="container">
         <div className="settingAccountPage desktopSection bgDesktopPage">
           <h4 className="titleSection">{t("profile.t1")}</h4>
           <div className="row">
             <div className="col-12 col-md-6 col-lg-4 col-xl-3">
               <label>{t("profile.t2")}</label>
               <input type="text" name="firstName" id="firstName" ref={firstNameRef}
                      style={handleBorderColor(selector?.public?.validations?.firstName)}
                      onChange={(e) => setFirstName(e.target.value)} value={firstName}/>
               {
                 selector?.public?.validations?.firstName &&
                 <p className="error">{selector?.public?.validations?.firstName}</p>
               }
             </div>
             <div className="col-12 col-md-6 col-lg-4 col-xl-3">
               <label>{t("profile.t3")}</label>
               <input type="text" name="lastName" id="lastName" ref={lastNameRef}
                      style={handleBorderColor(selector?.public?.validations?.lastName)}
                      onChange={(e) => setLastName(e.target.value)} value={lastName}/>
               {
                 selector?.public?.validations?.lastName &&
                 <p className="error">{selector?.public?.validations?.lastName}</p>
               }
             </div>
             <div className="col-12 col-md-6 col-lg-4 col-xl-3">
               <label>{t("profile.t17")}</label>
               <input type="text" name="nationalCode" id="nationalCode" ref={nationalCodeRef} className="numeric"
                      style={handleBorderColor(selector?.public?.validations?.nationalCode)}
                      onChange={(e) => e.target.value.length <= 10 && setNationalCode(removeNonNumeric(e.target.value))}
                      value={nationalCode}/>
               {
                 selector?.public?.validations?.nationalCode &&
                 <p className="error">{selector?.public?.validations?.nationalCode}</p>
               }
             </div>
             <div className="col-12 col-md-6 col-lg-4 col-xl-3">
               <label>{t("profile.t4")}</label>
               <input type="text" name="phone" id="phone" disabled value={phoneNumber}/>
               <span className="status">{t("profile.t5")}</span>
             </div>
             <div className="col-12 col-md-6 col-lg-4 col-xl-3">
               <label>{t("profile.t6")}</label>
               <input type="text" name="code" id="code" value={affiliate} onChange={(e) => setAffiliate(e.target.value)}/>
             </div>
             <div className="col-12 col-md-6 col-lg-4 col-xl-3">
               <label>{t("profile.t15")}</label>
               <PatternFormat name="cart" id="cart" value={cartNumber} valueIsNumericString format="#### #### #### ####" mask="-"
                              onValueChange={(value) => setCartNumber(value?.value)}
                              style={{direction: 'ltr'}}/>
             </div>
             <div className="col-12 col-md-6 col-lg-4 col-xl-3">
               <label>{t("profile.t16")}</label>
               <PatternFormat name="iban" id="iban" value={ibanNumber} valueIsNumericString format="IR## #### #### #### #### #### ##"
                              onValueChange={(value) => setIbanNumber(value?.value)}
                              style={{direction: 'ltr'}}/>
             </div>

             <div className="col-12">
               <div className="_btnGroup_yellow">
                 <button className="btnFill" id="validationInfo" disabled={isLoadingInfo} onClick={() => validationInfo()}>
                   {
                     isLoadingInfo ?
                        <Box sx={{display: 'flex'}}>
                          <CircularProgress size={20}/>
                        </Box>
                        :
                        <>
                          <span>{t("profile.t11")}</span>
                        </>
                   }
                   <SaveOutlined fontSize="large"/>
                 </button>
               </div>
             </div>

             {/*<h4 className="" style={{marginTop: '20px', marginBottom: '20px'}}>تغییر کلمه عبور</h4>*/}
             <div className="col-12">
               <h4 className="titleSection mt-4">{t("profile.t7")}</h4>
             </div>
             <div className="col-12 col-md-6 col-lg-4">
               <label>{t("profile.t9")}</label>
               <div className="input">
                 <Https/>
                 <input type={!showPassword ? 'password' : 'text'} name="password" ref={passwordRef}
                        style={handleBorderColor(selector?.public?.validations?.password)}
                        placeholder={t("newPassword.t3")}
                        id="password"
                        value={password}
                        className="inputPass" onChange={e => setPassword(onlyEnglish(e.target.value))}/>

                 <button type="button" onClick={() => setShowPassword(!showPassword)} id="showPassword">
                   {
                     showPassword ?
                        <VisibilityOff/>
                        :
                        <Visibility/>
                   }
                 </button>
               </div>
               {
                 (selector?.public?.validations?.password || errOnlyEnglish) &&
                 <p className="error">{selector?.public?.validations?.password || errOnlyEnglish}</p>
               }
             </div>

             <div className="col-12 col-md-6 col-lg-4">
               <label>{t("profile.t10")}</label>
               <div className="input">
                 <Https/>
                 <input type={!showConfirmPassword ? 'password' : 'text'} name="password" ref={confirmPasswordRef}
                        style={handleBorderColor(selector?.public?.validations?.confirmPassword)}
                        id="confirmPassword"
                        placeholder={t("newPassword.t4")}
                        value={confirmPassword}
                        className="inputPass" onChange={e => setConfirmPassword(onlyEnglish(e.target.value))}/>


                 <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} id="showConfirmPassword">
                   {
                     showConfirmPassword ?
                        <VisibilityOff/>
                        :
                        <Visibility/>
                   }
                 </button>
               </div>

               {
                 (selector?.public?.validations?.confirmPassword || errOnlyEnglish) &&
                 <p className="error">{selector?.public?.validations?.confirmPassword || errOnlyEnglish}</p>
               }
             </div>

             {
               changePass &&
               <div className="col-12 col-md-6 col-lg-4">
                 <label>{t("profile.t14")}</label>
                 <div className="input">
                   <Dialpad/>
                   <input type="text" name="code" id="otp" ref={codeRef}
                          style={handleBorderColor(selector?.public?.validations?.verifyCode)}
                          onChange={(e) => setVerifyCode(e.target.value)}/>
                 </div>
                 {
                   selector?.public?.validations?.verifyCode &&
                   <p className="error">{selector?.public?.validations?.verifyCode}</p>
                 }
               </div>
             }

             <div className="col-12">
               <div className="_btnGroup_yellow">
                 {
                   changePass ?
                      <button className="btnFill" id="validationCode" disabled={isLoadingPass} onClick={() => validationCode()}>
                        {
                          isLoadingPass ?
                             <Box sx={{display: 'flex'}}>
                               <CircularProgress size={20}/>
                             </Box>
                             :
                             <>
                               <span>{t("profile.t13")}</span>
                             </>
                        }
                        <VerifiedUser fontSize="large"/>

                      </button>
                      :
                      <button className="btnFill" id="validationPasswords" disabled={isLoadingPass} onClick={() => validationPasswords()}>
                        {
                          isLoadingPass ?
                             <Box sx={{display: 'flex'}}>
                               <CircularProgress size={20}/>
                             </Box>
                             :
                             <>
                               <span>{t("profile.t12")}</span>
                             </>
                        }
                        <Fingerprint fontSize="large"/>

                      </button>
                 }

               </div>
             </div>

           </div>
         </div>
       </div>
     </>
  )
}
